import React, { PropTypes } from 'react';
import { hideLoadingNav, hideLoadingFeed } from '../../utils/exploreHelpers';
import * as spt from '../../shared/propTypes';
import ExploreTabBar from './explore-tab-bar';
import ExploreFeed from './explore-feed';

import './explore.scss';

class App extends React.Component {
  static propTypes = {
    adTag: spt.adTag,
    isLoggedIn: PropTypes.bool.isRequired,
    loadingDiscoveryTimelines: PropTypes.bool,
    discoveryTimelines: PropTypes.arrayOf(spt.discoveryTimeline).isRequired,
    feedItems: PropTypes.object,
    isInitialFetchComplete: PropTypes.bool,
    currentTab: spt.discoveryTimeline,
    isFetching: PropTypes.object.isRequired,
    logData: PropTypes.object,
    onLoadDiscoveryTimelines: PropTypes.func.isRequired,
    onTabClick: PropTypes.func.isRequired,
    onExploreFeedScrollNearBottom: PropTypes.func.isRequired,
    onInitialFetchComplete: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        tab: React.string,
      }),
    }),
  }

  static defaultProps = {
    logData: {},
    loadingDiscoveryTimelines: false,
  }

  componentDidMount() {
    if (!this.props.discoveryTimelines.length > 0 && !this.props.loadingDiscoveryTimelines) {
      this.props.onLoadDiscoveryTimelines();
    } else if (!this.props.currentTab && this.props.discoveryTimelines.length > 0) {
      // Default to the first tab
      this.props.onTabClick(this.props.discoveryTimelines[0].timelineKey);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.updateSelectedTab(nextProps);
    if (!this.props.isInitialFetchComplete && nextProps.isInitialFetchComplete) {
      this.hideLoadingState(nextProps);
    }
    this.updateInitialFetchStatus(nextProps);
  }

  updateInitialFetchStatus({ loadingDiscoveryTimelines, isFetching }) {
    const anyFetching = Object.keys(isFetching).some(k => isFetching[k]);
    if (loadingDiscoveryTimelines || anyFetching) {
      return;
    }
    this.props.onInitialFetchComplete();
  }

  hideLoadingState() {
    hideLoadingNav();
    hideLoadingFeed();
  }

  updateSelectedTab(props) {
    if (props.discoveryTimelines.length === 0) {
      return;
    }

    let selectedTabKey = null;
    const defaultTabKey = props.discoveryTimelines[0].timelineKey;

    if (props.match.params.tab) {
      const selectedTab = props.discoveryTimelines.find((item) => {
        return item.timelineKey === props.match.params.tab;
      });
      if (selectedTab) {
        if (!props.currentTab || selectedTab.timelineKey !== props.currentTab.timelineKey) {
          selectedTabKey = selectedTab.timelineKey;
        }
      } else {
        selectedTabKey = defaultTabKey;
      }
    } else if (!props.currentTab) {
      selectedTabKey = defaultTabKey;
    }

    if (selectedTabKey) {
      props.onTabClick(selectedTabKey);
    }
  }

  render() {
    if (!this.props.isInitialFetchComplete) {
      return null;
    }
    if (this.props.loadingDiscoveryTimelines) {
      return (
        <div className="app-wrapper">
          <div className="explore-feed__spinner-container">
            <div className="explore-feed__spinner"></div>
          </div>
        </div>
      );
    }

    if (this.props.discoveryTimelines.length === 0) {
      return (
        <div className="app-wrapper">
        </div>
      );
    }
    return (
      <div className="app-wrapper uni-env--dark">
        <ExploreTabBar
          discoveryTimelines={this.props.discoveryTimelines}
          currentTab={this.props.currentTab}
          isLoggedIn={this.props.isLoggedIn}
          logData={this.props.logData}
        />

        {this.props.currentTab &&
          <ExploreFeed
            adTag={this.props.adTag}
            isFetching={this.props.isFetching}
            onExploreFeedScrollNearBottom={this.props.onExploreFeedScrollNearBottom}
            feedItems={this.props.feedItems}
            currentTab={this.props.currentTab}
            discoveryTimelines={this.props.discoveryTimelines}
          />}
      </div>
    );
  }
}

export default App;
